export enum PosthogActions {
  SET_FEATURE_FLAGS = '@posthog/SET_FEATURE_FLAGS',
  CLEAR_FEATURE_FLAGS = '@posthog/CLEAR_FEATURE_FLAGS',
}

export type TFeatureFlags =
  | 'menu_questions'
  | 'new_chapter_page'
  | 'menu_vip_classroom'
  | 'menu_upsell_premium'
  | 'menu_planning'

export type TFlagsPayload = Record<TFeatureFlags, Record<string, any>>

export type TState = {
  status: 'idle' | 'ok'
  featureFlags: Array<TFeatureFlags>
  payloads: TFlagsPayload
}
